import React, { Component } from 'react'

// Styles
import './index.scss'

// Constants
import { DETAIL } from './constants'

class ProjectDetail extends Component {

  constructor(props) {
    super(props)
    this.state = {
      data: {},
    }
  }

  componentDidMount = () => {
    this.getData()
  }

  // this will fetch data from constants.js based on url
  getData = () => {
    const { match } = this.props
    const content = DETAIL.find(item => item.link === match.params.url)
    this.setState({ data: content || {} })
  }

  render = () => {
    const { data } = this.state
    return (
      <React.Fragment>

        {
          Object.keys(data).length > 0 &&
          <div className="project-detail">

            <div className={`page-banner ${data.bg} vh-center`}>
              <div className="banner-content">
                <h2>{data && data.title}</h2>
              </div>
            </div>

            <div className="f-w">
              <div className="container">
                <div className="content">
                  <div className="overview">
                    <ul className="flex xlg-col-flex flex-wrap">
                      {
                        data && data.details.map((item, i) => {
                          return (
                            <li key={`detail${i}`}>
                              <h6>{item.key}</h6>
                              <h6>{item.value}</h6>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="preview-grid">
              <div className="flex xlg-col-flex flex-wrap">
                {
                  data && data.gallery.map((item, i) => {
                    return (
                      <div className="preview" key={`gallery${item}${i}`}>
                        <img src={item} alt="/" />
                        {/* <div className={`bg-image height-4 ${item}`}></div> */}
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>

        }
      </React.Fragment>

    )
  }
}

export default ProjectDetail